import { render, staticRenderFns } from "./standard.vue?vue&type=template&id=8fbc7330"
import script from "./standard.vue?vue&type=script&lang=ts"
export * from "./standard.vue?vue&type=script&lang=ts"
import style0 from "./standard.vue?vue&type=style&index=0&id=8fbc7330&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports